import { render, staticRenderFns } from "./CalendarItemView.vue?vue&type=template&id=68bf0b8e&scoped=true"
import script from "./CalendarItemView.vue?vue&type=script&lang=ts"
export * from "./CalendarItemView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf0b8e",
  null
  
)

export default component.exports